<div class="h-100 d-flex flex-column p-4">
    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
    >
    </dx-load-panel>

    @if (purchaseOrder$ | async; as purchaseOrder) {
        <div class="form-container">
            <div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
                <div class="card-header fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent py-3">
                    <div>Purchase Order Details</div>
                    <div class="text-muted">
                        ID: {{ purchaseOrder.purchasingDocument }}
                    </div>
                </div>
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <div class="mb-2">
                                <span class="fw-bold me-2">Status:</span>
                                <span class="badge" [ngClass]="getStatusBadgeClass(purchaseOrder.status)">{{ purchaseOrder.status | capitalCase }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Supplier</label>
                            <dx-text-box [value]="purchaseOrder.supplierNumber" [readOnly]="true" stylingMode="filled"></dx-text-box>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Supplying Plant</label>
                            <dx-text-box [value]="purchaseOrder.supplyingPlant" [readOnly]="true" stylingMode="filled"></dx-text-box>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dx-scroll-view class="view-wrapper-scroll">
            <app-purchase-order-items [purchaseOrderItems]="purchaseOrder.items"></app-purchase-order-items>
        </dx-scroll-view>
    }
</div>
